import './App.css';
import './assets/index.scss'
import Routes from "./routes/routes";
import {Provider} from 'react-redux';
import {HelmetProvider} from 'react-helmet-async';
import PersistedStore from "./store";
import Seo from "./components/Seo";

const store = PersistedStore.getDefaultStore().store;

const App = () => (
  <HelmetProvider>
    <Provider store={store}>
      <Seo/>
      <Routes/>
    </Provider>
  </HelmetProvider>
)

export default App;


